import Vue from 'vue';
import i18n from '@/i18n/i18n';
/**
 * Lớp xử lý hiển thị lọc cột
 * @author bnduc 24.9.2020
 */
class FilterHeaderUtil {
  /**
   * Hiển thị tùy chọn của cột
   */
  showOption(th, column, isLock) {
    var me = this,
      options = {},
      promise = null,
      frm = null;

    //ẩn options cũ đi
    let lastShow = window._lastThOption,
      // optionType = column.formatType;
      optionType = column.formatType ? column.formatType : th.$ms.enum.FormatType.Text;
    if (window._thOptions) frm = window._thOptions[optionType];
    let removeLastActive = function (optionFrm) {
      if (optionFrm.$el && typeof optionFrm.$el.closest === 'function') {
        let lastThEl = optionFrm.$el.closest('th');
        if (lastThEl) {
          let lastTh = me.$ms.commonFunc.mapDomToVue(lastThEl);
          if (lastTh) {
            lastTh.thOptionClass = null;
          }
        }
      }
    };

    if (lastShow && lastShow !== frm) {
      removeLastActive(lastShow);
      lastShow.hide();
    } else if (frm) {
      if (frm.ownerForm === th) {
        frm.col = column;
        frm.isLock = isLock;
        let isShow = frm.toggle(th.$el);
        th.thOptionClass = isShow ? 'active-option' : null;
        return;
      } else {
        removeLastActive(frm);
      }
    }
    if (!th.component) {
      let component = me.getOptionComponent(column, th);
      promise = new Promise((resolve, reject) => {
        let fnSuccess = function (module) {
          if (module && module.default) {
            th.component = module.default;
            me.showOptionDialog(th.component, th, options, column, isLock);
          }
        };

        let fnFailure = function (error) {
          me.$ms.commonFunc.handleException(error);
          reject(error);
        };

        component.then(fnSuccess, fnFailure);
      });
    } else {
      promise = me.showOptionDialog(th.component, th, options, column, isLock);
    }

    return promise;
  }

  /**
   * Lấy component của column
   */
  getOptionComponent(column, th) {
    switch (column.formatType) {
      case th.$ms.enum.FormatType.Enum:
        return import('@/components/msgridviewerx/columnoption/msThOptionEnum.vue');
      case th.$ms.enum.FormatType.EnumOne:
        return import('@/components/msgridviewerx/columnoption/msThOptionEnumOne.vue');
      case th.$ms.enum.FormatType.UnitPrice:
      case th.$ms.enum.FormatType.Amount:
      case th.$ms.enum.FormatType.Rate:
      case th.$ms.enum.FormatType.ExchangeRate:
      case th.$ms.enum.FormatType.UnitPriceOC:
      case th.$ms.enum.FormatType.AmountOC:
      case th.$ms.enum.FormatType.Number:
      case th.$ms.enum.FormatType.Allocation:
      case th.$ms.enum.FormatType.QuantityConvert:
      case th.$ms.enum.FormatType.WorkDay:
      case th.$ms.enum.FormatType.Quantity:
        return import('@/components/msgridviewerx/columnoption/msThOptionNumber.vue');
      case th.$ms.enum.FormatType.Date:
      case th.$ms.enum.FormatType.DateTime:
      case th.$ms.enum.FormatType.Time:
        return import('@/components/msgridviewerx/columnoption/msThOptionDate.vue');
      default:
        return import('@/components/msgridviewerx/columnoption/msThOptionText.vue');
    }
  }

  /**
   * Hiển thị tùy chọn của cột
   */
  showOptionDialog(component, owner, options, column, isLock) {
    const me = this;
    let promise = new Promise((resolve, reject) => {
      if (owner && component) {
        let frm = this.prepareForDialog(column, component, owner, {
          i18n,
          propsData: {
            col: column,
            isLock: isLock,
            ownerForm: owner,
          }
        });
        if (frm) {
          window._lastThOption = frm;
          frm.ownerForm = owner;
          frm.col = column;
          frm.isLock = isLock;
          frm.show(owner.$el);
          owner.thOptionClass = 'active-option';
          me.afterShowOptionDialogAction(frm, owner, column);
        }
      }
    });

    return promise;
  }

  /**
   * Hàm xử lý sau khi bổ sung dữ liệu vào dialog option
   * @author nvhien - 09-01-2025
   * @param {*} frm 
   * @param {*} owner 
   * @param {*} column 
   * @returns 
   */
  afterShowOptionDialogAction(frm, owner, column) {
    if (!frm || !owner) return;
    switch (column.formatType) {
      case owner.$ms.enum.FormatType.Enum:
        //load dữ liệu
        frm.loadDataSource();
        break;
      case owner.$ms.enum.FormatType.EnumOne:
      case owner.$ms.enum.FormatType.UnitPrice:
      case owner.$ms.enum.FormatType.Amount:
      case owner.$ms.enum.FormatType.Rate:
      case owner.$ms.enum.FormatType.ExchangeRate:
      case owner.$ms.enum.FormatType.UnitPriceOC:
      case owner.$ms.enum.FormatType.AmountOC:
      case owner.$ms.enum.FormatType.Number:
      case owner.$ms.enum.FormatType.Allocation:
      case owner.$ms.enum.FormatType.QuantityConvert:
      case owner.$ms.enum.FormatType.WorkDay:
      case owner.$ms.enum.FormatType.Quantity:
      case owner.$ms.enum.FormatType.Date:
      case owner.$ms.enum.FormatType.DateTime:
      case owner.$ms.enum.FormatType.Time:
        break;
      default:
        break;
    }
  }

  /**
   * Xử lý hiển thị dialog
   * @author DNThang - 30.10.2019
   * DNThang - 06.05.2020: Trong trường hợp owner là popup thì sẽ append vào content để không bị chìm ở dưới
   */
  prepareForDialog(column, component, owner, options) {
    const me = this,
      optionType = column.formatType;

    let frm = null;
    if (window._thOptions) frm = window._thOptions[optionType];
    if (!frm) {
      var frmType = Vue.extend(component);
      frm = new frmType(options);
      frm.$mount();
      window._thOptions[optionType] = frm;
    }

    // owner.$el.appendChild(frm.$el);
    document.body.appendChild(frm.$el);
    return frm;
  }
  /**
   * Sinh ra function để lọc local cho 1 số màn hình danh sách
   * @param {String} keyword Từ khóa tìm kiếm
   * @param {Array} columns danh sách cột của grid
   * @param {Array} filter bộ lọc của grid
   * @author NVLAM 01.12.2020
   */
  generateFilterFn(keyword, columns) {
    let filterFn = null,
      words = this.$ms.commonFunc.splitKeyWord(keyword);
    filterFn = function (data) {
      let match = false;
      for (let i = 0; i < columns.length; ++i) {
        let col = columns[i];
        if (col.columnType === 'ColumnText' || col.columnType === 'ColumnDrilldown') {
          let field = col.dataField;
          match = words.every(w => data[field].includes(w));
        }
        if (match) {
          break;
        }
      }
      return match;
    };
    return filterFn;
  }
}

export default new FilterHeaderUtil();
